import { useState } from "react"
import { ChevronDown, FunctionSquare } from "lucide-react"

export default function FormulaBox({ title = "How is this calculated?", formula, description }: { title?: string, formula: string, description?: string }) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="mt-8 border border-slate-200 rounded-xl overflow-hidden bg-white">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-4 bg-slate-50 hover:bg-slate-100 transition-colors focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary"
      >
        <span className="flex items-center text-sm font-semibold text-slate-700">
          <FunctionSquare className="w-4 h-4 mr-2 text-slate-400" />
          {title}
        </span>
        <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      
      {isOpen && (
        <div className="p-5 border-t border-slate-200">
          {description && <p className="text-sm text-slate-600 mb-3">{description}</p>}
          <div className="bg-slate-900 text-slate-50 p-4 rounded-lg overflow-x-auto font-mono text-sm leading-relaxed whitespace-pre">
            {formula}
          </div>
        </div>
      )}
    </div>
  )
}
